export const useWordProcessor = (instanceId: string) =>
  defineStore(`/word-processor/${instanceId}`, () => {
    const selectionRange = ref<{ index: number; length: number } | undefined>(
      undefined
    );

    const quillDelta = ref<any | undefined>(undefined);

    const editorRef = ref<any>(null);
    const isEditorReady = ref(false);
    const shouldShowFormatting = ref(false);

    watch(quillDelta, (newVal) => {
      if (selectionRange.value) {
        selectionRange.value = {
          ...selectionRange.value,
        };
      }
    });

    const setEditorReady = (ready: boolean) => {
      isEditorReady.value = ready;
    };

    const setShouldShowFormatting = (value: boolean) => {
      shouldShowFormatting.value = value;
    };

    const toggleShouldShowFormatting = () => {
      shouldShowFormatting.value = !shouldShowFormatting.value;
    };

    const resetEditorState = () => {
      isEditorReady.value = false;
      editorRef.value = null;
      selectionRange.value = undefined;
      shouldShowFormatting.value = false;
    };

    const getQuillInstance = () => {
      if (editorRef.value == null) {
        return undefined;
      }

      try {
        return editorRef.value.getQuill?.() ?? undefined;
      } catch (error: any) {
        const message = String(error ?? "");
        if (message.includes("hasn't been instantiated yet")) {
          return undefined;
        }

        return undefined;
      }
    };

    return {
      selectionRange,
      quillDelta,
      editorRef,
      isEditorReady,
      shouldShowFormatting,
      setEditorReady,
      setShouldShowFormatting,
      toggleShouldShowFormatting,
      resetEditorState,
      getQuillInstance,
    };
  });
